import { z } from 'zod';

export const SignInSchema = z.object({
  email: z.string().email('Alamat email tidak valid'),
  password: z.string().min(1, 'Password harus diisi'),
});

export type FormFields = z.infer<typeof SignInSchema>;
